module.exports = __webpack_public_path__ + "2eff16383d7b7eed81a1d76dc2148f00.jpg";